function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      enableBackground: "accumulate"
    },
    d: "M13 964.362c-2.216 0-4 1.784-4 4v8h8.094l10.343-12H13zm19.688 0-10.344 12h14.75l10.344-12h-14.75zm20 0-10.344 12h14.75l10.344-12h-14.75zm20 0-10.344 12H79v-8c0-2.216-1.784-4-4-4h-2.313zM9 980.362v44c0 2.216 1.784 4 4 4h47.219l12.781-23 6 10.813v-35.813H9zm30 14 16 10-16 10v-20zm34 14-18 32h36l-18-32zm0 8a2 2 0 0 1 2 2v11a2 2 0 1 1-4 0v-11a2 2 0 0 1 2-2zm0 16a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z",
    overflow: "visible",
    transform: "translate(0 -952.362)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionError);
export default __webpack_public_path__ + "static/media/connection-error.3128f0db32ff61ab9b4e978fa8b41699.svg";
export { ForwardRef as ReactComponent };